import { render, staticRenderFns } from "./tech-empowerment.vue?vue&type=template&id=274a178c&scoped=true"
import script from "./tech-empowerment.vue?vue&type=script&lang=js"
export * from "./tech-empowerment.vue?vue&type=script&lang=js"
import style0 from "./tech-empowerment.vue?vue&type=style&index=0&id=274a178c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_j7fuxwmg3pjjrof4ryv5g7uhre/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "274a178c",
  null
  
)

export default component.exports